module.exports = __webpack_public_path__ + "img/client-say-3.e4d2ed61.png";